import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import * as dateHelper from '@appbase/util/date-helper'
import DatePicker from '@appbase/components/DatePicker/DatePicker.vue';
import GridView from '@appbase/components/GridView/GridView.vue'
import PageNavigationBar from '@appbase/components/Paginate/PageNavigationBar.vue'
import * as typesAccount from '@account/store/types'
import { mapGetters } from 'vuex';
import LoadingBar from '@appbase/components/loading/LoadingBar.vue'
import api from '@home/api'

@Component({
    components: { DatePicker, GridView, LoadingBar, PageNavigationBar },
    computed: mapGetters({
        user: typesAccount.USER,
    }),
})
export default class PurchaseHistory extends Vue {

    user!: account.User;
    isLoading: boolean = false
    
    activeTab: string = 'offline'
    searchStartDate: string = '';
    searchEndDate: string = '';
    templateHeaders: gridView.Header[] = []

    page: number = 1;
    perPage: number = 15;
    totalCount: number = 0;
    purchaseHistoryList: any = []

    bo_token: string = ''

    get totalAmount() {
        var total = 0
        if(this.purchaseHistoryList){
            this.purchaseHistoryList.map((p: any) => {
                total += this.activeTab === 'offline' ? Number(p.saleAmt) : Number(p.slsAmnt)
            })
        }
        return this.convertAmountFormat(total??0)
    }

    get offlineActive(){
        return this.activeTab === 'offline'
    }

    get onlineActive(){
        return this.activeTab === 'online'
    }

    setHeaders(){
        if(this.activeTab === 'online'){
            this.templateHeaders = [
                { displayName: this.$t('매출일자').toString(), rowKey: 'slsDate', width: '100', align: 'center'},
                { displayName: this.$t('주문번호').toString(), rowKey: 'ordrId', width: '130', align: 'center'},
                { displayName: this.$t('상품코드').toString(), rowKey: 'cmdtcode', width: '130', align: 'center'},
                { displayName: this.$t('상품명').toString(), rowKey: 'cmdtName'},
                { displayName: this.$t('수량').toString(), rowKey: 'qntt', width: '80', align: 'center'},
                { displayName: this.$t('합계').toString(), rowKey: 'slsAmnt', width: '100', align: 'right', slotName: 'amount'},
                { displayName: this.$t('수령구분').toString(), rowKey: 'dlvrShpName', width: '100', align: 'center'}
            ]
        }
        else if(this.activeTab === 'offline'){
            this.templateHeaders = [
                { displayName: this.$t('판매일자').toString(), rowKey: 'saleDate', width: '150', align: 'center'},
                { displayName: this.$t('판매점').toString(), rowKey: 'storeNm', width: '100', align: 'center'},
                { displayName: this.$t('POS번호').toString(), rowKey: 'posNo', width: '100', align: 'center'},
                { displayName: this.$t('거래번호').toString(), rowKey: 'tranNo', width: '100', align: 'center'},
                { displayName: this.$t('순번').toString(), rowKey: 'seq', width: '80', align: 'center'},
                { displayName: this.$t('상품명').toString(), rowKey: 'cmdtName'},
                { displayName: this.$t('수량').toString(), rowKey: 'qty', width: '80', align: 'center'},
                { displayName: this.$t('합계').toString(), rowKey: 'saleAmt', width: '170', align: 'right', slotName: 'amount'}
            ]
        }
        this.loadHistory()
    }

    convertAmountFormat(val: number) {
        return val.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
    }

    pageMove(page: number) {
        this.page = page
    }

    resetDate() {
        const today = new Date()
        this.searchEndDate = dateHelper.uGetDateFormat('yyyy-MM-dd', today)
        this.searchStartDate = dateHelper.uGetDateFormat('yyyy-MM-dd', new Date(today.setDate(today.getDate() - 7)))
    }

    dateValidationCheck(){
        if(new Date(this.searchStartDate).getTime() > new Date(this.searchEndDate).getTime()){
            (window as any).alertAsync(this.$t('M_Hours_CannotEarierStart'))
            this.isLoading = false
            return false
        }
        if(this.activeTab === 'online'){
            var startDate = new Date(this.searchStartDate);
            var endDate = new Date(this.searchEndDate);

            var compareDate = new Date(startDate.setMonth(startDate.getMonth()+3))
            if(endDate.getTime() > compareDate.getTime()){
                (window as any).alertAsync(this.$t('조회기간은_3개월범위로만_가능합니다'))
                this.isLoading = false
                return false
            }
        }
        return true
    }

    async loadHistory(){
        if(this.dateValidationCheck()){
            this.isLoading = true
            var stsDate = this.searchStartDate.replaceAll('-','')
            var endDate = this.searchEndDate.replaceAll('-','')
            if(this.activeTab === 'offline'){
                api.kyobobook.getOfflinePurchase(stsDate,endDate).then(res=>{
                    var result = JSON.parse(res)
                    if(result){
                        this.purchaseHistoryList = result.data??[]
                    }
                    this.isLoading = false
                })
            }
            else{
                api.kyobobook.getOnlinePurchase(stsDate,endDate).then(res=>{
                    var result = JSON.parse(res)
                    if(result){
                        this.purchaseHistoryList = result.data??[]
                    }
                    this.isLoading = false
                })
            }
        }
    }

    created() {
        this.resetDate()
        this.setHeaders()
    }

    @Watch('activeTab')
    onChangedTab(tab: string){
        this.purchaseHistoryList = []
        this.setHeaders()
    }
}
